import React from 'react';
import { notificationType } from './../shared_proptypes';
import NotificationItemDetails from "../NotificationItemDetails";

function DiscoveredPhoneNumberNotification({ notification }) {
  const campaignButton = {
    url: notification.link,
    label: `Go to Campaign ${notification.campaignName} - Main`
  };
  const campaignButtons = [campaignButton];
  return (
    <span className="notification-item" data-test-id="notification_template">
      <NotificationItemDetails
        orgType="Advertiser"
        orgName={notification.advertiserName}
        message={notification.message}
        buttonConfigs={campaignButtons}
      />
    </span>
  );
}

DiscoveredPhoneNumberNotification.propTypes = {
  notification: notificationType().isRequired
};

export default DiscoveredPhoneNumberNotification;
